import React, { useEffect, useState } from "react";
import { myLocalStorage } from "../../../components/StorageHelper";
import axios from "axios";
import { NGROK } from "../../../APIs";
import useUserStore from "../../../services/userStore";
import CloudAnomalyAlertsTable from "../../../components/v2components/CloudSightAlerts/components/CloudAnomalyAlertsTable";

const AZURECloudAlerts = () => {
    const [selectedTenantName, setSelectedTenantName] = useState(null);
    const [tenantList, setTenantList] = useState([]);
    const [subscriptionId, setSubscriptionId] = useState(null);
    const [subscriptionIdList, setSubscriptionIdList] = useState([]);
    const userData = useUserStore((state) => state.user);

    const latestSubList = myLocalStorage.getItem("latestSubList");
    const latestSubscriptionId = typeof latestSubList === 'string'
        ? JSON.parse(latestSubList)?.azureSubscriptionId
        : latestSubList?.azureSubscriptionId;
    const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;

    const handleSubscription = (value) => {
        const sub = subscriptionIdList.find((p) => p.azureSubscriptionId === value);
        if (sub !== undefined) {
            setSubscriptionId(sub.azureSubscriptionId);
            myLocalStorage.setItem("latestSubList", JSON.stringify(sub));
        }
    };

    const handleTenantChange = (value) => {
        const tenant = tenantList.find((t) => t.tenantName === value);
        if (tenant !== undefined) {
            setSelectedTenantName(tenant.tenantName);
            myLocalStorage.setItem("latestTenant", tenant);
        }
    };

    const fetchSubscriptionIdList = async () => {
        if (!latestTenant) {
            setSubscriptionIdList([]);
            return;
        }

        try {
            const response = await axios.get(
                `${NGROK}/api/azureResources/v1/all`,
                {
                    params: {
                        tenantName: latestTenant,
                        type: "SUBSCRIPTION",
                    },
                }
            );

            const subs = response?.data || [];
            setSubscriptionIdList(subs);
        } catch (error) {
            console.error("Failed to fetch subscriptions:", error);
            setSubscriptionIdList([]);
        }
    };

    useEffect(() => {
        fetchSubscriptionIdList();
        const interval = setInterval(() => {
            fetchSubscriptionIdList();
        }, 10000);
        return () => clearInterval(interval);
    }, [latestTenant, latestSubscriptionId]);

    useEffect(() => {
        if (tenantList.length === 1) {
            setSelectedTenantName(tenantList[0].tenantName);
            return;
        }

        if (tenantList.length > 1) {
            const storedTenantName = myLocalStorage.getItem("latestTenant")?.tenantName;
            const tenant =
                tenantList.find((t) => t.tenantName === storedTenantName) ||
                tenantList[0];
            setSelectedTenantName(tenant.tenantName);
        }
    }, [tenantList]);

    useEffect(() => {
        if (subscriptionIdList.length === 1) {
            myLocalStorage.setItem("latestSubList", JSON.stringify(subscriptionIdList[0]));
            setSubscriptionId(subscriptionIdList[0].azureSubscriptionId);
            return;
        }

        if (subscriptionIdList.length > 1) {
            const storedSubList = myLocalStorage.getItem("latestSubList");
            const storedSubscriptionId = typeof storedSubList === 'string'
                ? JSON.parse(storedSubList)?.azureSubscriptionId
                : storedSubList?.azureSubscriptionId;
            const sub = subscriptionIdList.find((p) => p.azureSubscriptionId === storedSubscriptionId);

            if (sub) {
                setSubscriptionId(sub.azureSubscriptionId);
            } else {
                myLocalStorage.setItem("latestSubList", JSON.stringify(subscriptionIdList[0]));
                setSubscriptionId(subscriptionIdList[0].azureSubscriptionId);
            }
        }
    }, [subscriptionIdList]);

    useEffect(() => {
        const fetchTenants = async () => {
            const response = await axios.get(`${NGROK}/api/get-all-domains`);
            setTenantList(response.data || []);
        };

        fetchTenants();
    }, [userData]);

    return (
        <CloudAnomalyAlertsTable
            cloud="AZURE"
            cloudId={subscriptionId}
            tenantName={selectedTenantName}
            tenantList={tenantList}
            cloudIdList={subscriptionIdList.map(s => s.azureSubscriptionId)}
            onTenantChange={handleTenantChange}
            onCloudIdChange={handleSubscription}
        />
    );
};

export default AZURECloudAlerts;